$(".header__nav").on("click", ".header__link--services", function(e) {
  e.preventDefault();
  e.stopPropagation();
  $("body").toggleClass("no-scroll");
  $(this).toggleClass("active");
  $(".js-services-dropdown").toggleClass("active");

  $(document).on("click", function(e) {
    e.stopPropagation();
    $(".header__dropdown.active").removeClass("active");
  });
});

$(".hamburger").on("click", function(e) {
  e.preventDefault();
  e.stopPropagation();
  $(this).toggleClass("is-active");
  $(".header").toggleClass("active");
  $(".header__nav").toggleClass("active");
  $("body").toggleClass("overflow");
});

mobile_submenu();

function mobile_submenu() {
  $(".has-mobile-submenu").on("click", function(e) {
    $(this).toggleClass("submenu-is-open");
    $(this)
      .children(".mobile-submenu")
      .slideToggle(300);
  });
}
